module.exports = __webpack_public_path__ + "assets/img/user.47ce7e8c.svg";